//TODO change file name to base.ts to enable typescript
export default {
    getRoles () {
        return {
            SUPERADMIN: 'super_admin',
            ADMINISTRATOR: 'admin',
            NUTZER: 'user'
        }
    }
}